import { useRef, useCallback } from 'react';
import { findHoveredGate, calculateTooltipPosition, TOOLTIP_OFFSET } from 'utils/tooltip';

const useGateTooltip = (gates) => {
  const tooltipRef = useRef(null);

  // Memoized function to check if mouse is over a gate
  const isMouseOverRect = useCallback(
    (mouseX, mouseY) => findHoveredGate(mouseX, mouseY, gates),
    [gates],
  );

  // Positions the tooltip and makes it visible
  const positionTooltip = useCallback((event) => {
    const tooltip = tooltipRef.current;
    const { x, y } = calculateTooltipPosition(event, tooltip, TOOLTIP_OFFSET);
    tooltip.style.left = `${x}px`;
    tooltip.style.top = `${y}px`;
    tooltip.style.visibility = 'visible';
  }, []);

  const showTooltip = useCallback((hoveredRect) => {
    const tooltip = tooltipRef.current;
    tooltip.innerHTML = `${hoveredRect.name}`;
    if (hoveredRect.parametersList?.length) {
      const parametersList = `${hoveredRect.parametersList.reduce(
        (acc, param, index) => acc + (index > 0 ? ', ' : '') + (!isNaN(Number(param)) ? Number(param).toFixed(2) : param),
        '(',
      )})`;

      tooltip.innerHTML += parametersList;
    }
    tooltip.style.display = 'block';
    // Hide during positioning to prevent flicker
    tooltip.style.visibility = 'hidden';
  }, []);

  const handleMouseMove = useCallback(
    (event, canvas) => {
      const tooltip = tooltipRef.current;

      // Convert page coordinates to canvas coordinates
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      // Check if mouse is over a Rect, and get name
      const hoveredRect = isMouseOverRect(mouseX, mouseY);

      if (hoveredRect) {
        showTooltip(hoveredRect);
        positionTooltip(event);
      } else {
        tooltip.style.display = 'none';
      }
    },
    [isMouseOverRect, positionTooltip, showTooltip],
  );

  return {
    tooltipRef,
    handleMouseMove,
  };
};

export default useGateTooltip;
